var _excluded = ["id", "values", "activeIndex", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import { KeyboardEventKeys } from "../../../typings/types";
import { Toggle, Label, ToggleWrapper } from "./ToggleWithLabelsAtm.styled";
function ToggleWithLabelsAtm(_ref) {
  var id = _ref.id,
    values = _ref.values,
    activeIndex = _ref.activeIndex,
    onClick = _ref.onClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var hasActive = !!values[activeIndex];
  var hasFirstElementActive = activeIndex === 0;
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === KeyboardEventKeys.ENTER || event.key === KeyboardEventKeys.SPACE) {
      event.preventDefault();
      onClick();
    }
  };
  return /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: "backgroundLight"
  }, /*#__PURE__*/React.createElement(ToggleWrapper, {
    id: id
  }, /*#__PURE__*/React.createElement(Toggle, _extends({
    $hasActive: hasActive,
    $hasFirstElementActive: hasFirstElementActive,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    tabIndex: 0
  }, restProps), values.map(function (value, index) {
    var isActive = activeIndex === index;
    return /*#__PURE__*/React.createElement(Label, {
      key: value,
      emphasis: isActive ? "high" : "half",
      typography: "nano1"
    }, value);
  }))));
}
export default ToggleWithLabelsAtm;